import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { MdClose } from "react-icons/md";
import { Modal as ResponsiveModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";

const Modal = ({ isOpen, onClose, onConfirm, description, title }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    await onConfirm();
    setIsLoading(false);
  };

  return (
    <ResponsiveModal
      open={isOpen}
      onClose={onClose}
      center
      closeIcon={<MdClose />}
      classNames={{
        modal: "p-6 rounded-md  w-full shadow-lg",
      }}
      styles={{
        modal: {
          padding: "24px",
          borderRadius: "12px",
          maxWidth: "480px", // Smaller width
          width: "90%", // Responsive
        },
      }}
    >
      <h2 className="text-xl font-semibold mb-4 capitalize">{title}</h2>
      <p className="text-gray-700">{description}</p>

      <button
        disabled={isLoading}
        onClick={handleConfirm}
        className="btn btn-primary bg-[var(--primary-color)] w-fit mt-5 px-10 py-2 text-white rounded-full ml-auto block"
      >
        {isLoading ? (
          <CgSpinner className="animate-spin" size={20} />
        ) : (
          "Confirm"
        )}
      </button>
    </ResponsiveModal>
  );
};

export default Modal;
